import 'css-chunksrc/client/scenes/preferences/calendar/styles.scss';export default {
  "calendarPreference": "_calendarPreference_127rt_1",
  "calendarHolidays": "_calendarHolidays_127rt_8",
  "description": "_description_127rt_14",
  "caseCalendar": "_caseCalendar_127rt_20",
  "formData": "_formData_127rt_43",
  "inputTime": "_inputTime_127rt_51",
  "displayButton": "_displayButton_127rt_60",
  "button": "_button_127rt_66",
  "hideElement": "_hideElement_127rt_75",
  "readOnly": "_readOnly_127rt_80"
};